import { ViewModel,View } from "binder"
import { TemplateSelectorEditorViewModel } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/templateSelectorEditor/templateSelectorEditor-viewModel";
import { IExecutablePart, IExecutablePartVisitor } from "../executablePart";
import  { ShowPopupView } from "./showPopup-view"

export class ShowPopupViewModel extends ViewModel implements IExecutablePart{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.templateSelector = new TemplateSelectorEditorViewModel(this);
    }
    GetDefaultView(): View <ViewModel> {
        return new ShowPopupView();
    }
    public getTypeId(): string {
        return "VM-DC0BCC70-A6AA-4672-8A57-C5B9E38423BC"
    }

    public set VariableName(v: string) { this._VariableName = v; } public get VariableName(): string { return this._VariableName;} private _VariableName: string;
    public set templateSelector(v: TemplateSelectorEditorViewModel) { this._templateSelector = v; } public get templateSelector(): TemplateSelectorEditorViewModel { return this._templateSelector;} private _templateSelector: TemplateSelectorEditorViewModel;
    public set popupWidth(v: string) { this._popupWidth = v; } public get popupWidth(): string { return this._popupWidth;} private _popupWidth: string;
    public set popupHeight(v: string) { this._popupHeight = v; } public get popupHeight(): string { return this._popupHeight;} private _popupHeight: string;
    public set waitUntilFinish(v: boolean) { this._waitUntilFinish = v; } public get waitUntilFinish(): boolean { return this._waitUntilFinish;} private _waitUntilFinish: boolean;
    public set returnVariableName(v: string) { this._returnVariableName = v; } public get returnVariableName(): string { return this._returnVariableName;} private _returnVariableName: string;
    

    accept(visitor: IExecutablePartVisitor, parameter: any) {
        return visitor.VisitShowPopup(this,parameter);
    }
    
}
